import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id C05A4C2F-8128-474F-B204-D782A332CB73
 * name circle-multiple
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/circle-multiple.svg
 * tags
 * - Currency 
 * - Banking 
 */
export const CircleMultipleIcon = createSvgIcon(<><path d="M15 4A8 8 0 1 1 7 12A8 8 0 0 1 15 4M3 12A6 6 0 0 0 7 17.65V19.74A8 8 0 0 1 7 4.26V6.35A6 6 0 0 0 3 12Z" /></>, 'CircleMultipleIcon');
export default CircleMultipleIcon